import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ManagementFocus = () => {
  const { t } = useTranslation();

  const focusAreas = [
    {
      icon: 'ri-compass-line',
      title: t('management.focus.strategy.title'),
      description: t('management.focus.strategy.description'),
    },
    {
      icon: 'ri-calendar-line',
      title: t('management.focus.release.title'),
      description: t('management.focus.release.description'),
    },
    {
      icon: 'ri-store-2-line',
      title: t('management.focus.brand.title'),
      description: t('management.focus.brand.description'),
    },
    {
      icon: 'ri-map-pin-line',
      title: t('management.focus.live.title'),
      description: t('management.focus.live.description'),
    },
    {
      icon: 'ri-earth-line',
      title: t('management.focus.crossBorder.title'),
      description: t('management.focus.crossBorder.description'),
    },
  ];

  return (
    <section className="bg-cream py-16 sm:py-32">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="font-western text-xl sm:text-3xl font-bold text-orange-burnt mb-6 sm:mb-8 uppercase">
            {t('management.focus.title')}
          </h2>
        </div>

        {/* Focus Areas Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8 mb-10 sm:mb-16">
          {focusAreas.map((area, index) => (
            <div
              key={index}
              className="bg-leather-dark/5 border-2 border-leather-dark/20 p-6 sm:p-10 hover:border-orange-burnt transition-all duration-300"
            >
              <div className="flex items-start gap-4 sm:gap-6">
                <div className="w-11 h-11 sm:w-14 sm:h-14 flex items-center justify-center bg-orange-burnt/10 border-2 border-orange-burnt flex-shrink-0">
                  <i className={`${area.icon} text-xl sm:text-2xl text-orange-burnt`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="font-western text-base sm:text-xl font-bold text-leather-dark mb-2 sm:mb-3">
                    {area.title}
                  </h3>
                  <p className="font-sans text-sm sm:text-base text-leather-dark/70 leading-relaxed">
                    {area.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/contact"
            className="inline-block bg-orange-burnt text-cream px-8 sm:px-12 py-4 sm:py-5 rounded-none font-sans text-sm sm:text-base font-bold uppercase tracking-wider hover:bg-leather-dark hover:border-leather-dark transition-all whitespace-nowrap cursor-pointer border-2 border-orange-burnt"
          >
            {t('management.cta')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ManagementFocus;
